/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function WallItemMeshFromJSON(json) {
    return WallItemMeshFromJSONTyped(json, false);
}
export function WallItemMeshFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'meshStorageUrl': !exists(json, 'mesh_storage_url') ? undefined : json['mesh_storage_url'],
    };
}
export function WallItemMeshToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mesh_storage_url': value.meshStorageUrl,
    };
}
//# sourceMappingURL=WallItemMesh.js.map